import { ReactComponent as building } from "./assets/icons/building.svg";
import { ReactComponent as chicken } from "./assets/icons/chicken.svg";
import { ReactComponent as empty } from "./assets/icons/empty.svg";
import { ReactComponent as pig } from "./assets/icons/pig.svg";
import { ReactComponent as tuffBuilding } from "./assets/icons/tuffBuilding.svg";

export const Icons = {
  chicken,
  building,
  tuffBuilding,
  pig,
  empty,
};
